import { GetSteps } from "ui/organisms/ReferenceTrack/ReferenceTrack";
import { referenceTrackDailyLivesMeterId } from "ui/organisms/ReferenceTrack/referenceTrackIds";
import { sharedReferenceTrackConfig } from "ui/templates/Game/sharedReferenceTrackConfig";

export const refrenceTrackIds = {
  playbackState: "playback-state",
  graph: "graph",
  submit: "submit",
};

export const referenceTrackSteps: GetSteps = ({ showAllSharedGameSteps }) => [
  showAllSharedGameSteps && {
    target: `#${refrenceTrackIds.playbackState}`,
    title: "Playback State",
    content: sharedReferenceTrackConfig.playbackState,
    placement: "auto",
  },
  {
    target: `#${refrenceTrackIds.graph}`,
    title: "Match the EQ",
    content: (
      <div>
        <p className={"mb-2"}>
          Slide the EQ left and right until your mix and the ref sound exactly
          the same.
        </p>

        <p>
          The 'safe area' is the white boundary around the needle. Taht is the
          buffer room before your answer is wrong. The harder the game, the
          smaller this area will be.
        </p>
      </div>
    ),

    placement: "auto",
  },
  showAllSharedGameSteps && {
    target: `#${refrenceTrackIds.submit}`,
    title: "Submit your answer",
    content: (
      <div>
        <p>
          Once you are sure your mix sounds the same as the reference hit
          submit.
        </p>
      </div>
    ),

    placement: "auto",
  },
  showAllSharedGameSteps && {
    target: `#${referenceTrackDailyLivesMeterId}`,
    title: "Daily Lives Meter",
    content: sharedReferenceTrackConfig.dailyLivesMeter,
  },
];
